export const csvGenerator = (csv: string, fileName?: string) => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.download = fileName || 'report.csv';
  a.click();
};
